export default __webpack_public_path__ + "static/media/assess-walk-4.b354d182.gif";